// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3Q1uS","amount":"Amount_amount__1kudW","tip":"Amount_tip__2JobC","tipHeader":"Amount_tipHeader__2oTxC","tipsWrap":"Amount_tipsWrap__2UKyd"};